
export class ResponseDTO {

    username: string | null;

    perfil: string | null;

    token: string | null;

    constructor(username: string | null, perfil: string | null, token: string | null) {

        this.username = username;

        this.perfil = perfil;

        this.token = token;
    }

}
